import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    balance: 'Balance at {from}',
    earnings: 'Inflows',
    spendings: 'Outflows',
  },
  fr: {
    balance: 'Solde au {from}',
    earnings: 'Entrées d’argent',
    spendings: 'Sorties d’argent',
  },
} as const);

export default locales;
